export const PAYLATER_BACKEND = "https://pay-later-dev.feemonk.com";
export const APPLICATIONS_BACKEND = "https://staging-backend.feemonk.com";
